import React from 'react'
import Avatar from 'react-avatar-edit'
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import './profileAvatar.css';

class ProfileAvatar extends React.Component {

    constructor(props) {
        super(props)
        const src = this.props.image ? this.props.image : 'https://via.placeholder.com/150';

        this.state = {
            preview: src,
            src,
            openEditor: false,
        }
        this.onCrop = this.onCrop.bind(this)
        this.onClose = this.onClose.bind(this)
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        const src = nextProps.image ? nextProps.image : 'https://via.placeholder.com/150';
        if (nextProps && (prevState.preview !== src)) {
            return { preview: src };
        }
            

        return null;
    }

    onClose() {
        this.setState({ openEditor: false });
    }

    onCrop(preview) {
        this.setState({ preview });
        this.props.onChange(preview.split(',')[1]);
    }

    onOpenEditor = () => {
        this.setState({ src: null });
        this.setState({ openEditor: true });
    }   

    render() {
        return (
            <React.Fragment>
                <Popover placement="bottom" isOpen={this.state.openEditor} target="previewImage" toggle={this.onClose} style={{maxWidth:'none', overflow:'hidden'}} trigger = 'legacy'>
                    <PopoverHeader>Profile Image</PopoverHeader>
                    <PopoverBody>
                        <Avatar
                            width={390}
                            height={295}
                            onCrop={this.onCrop}
                            onClose={this.onClose}
                            src={this.state.src}
                        />
                    </PopoverBody>
                </Popover>

                <img id='previewImage' src={this.state.preview} alt="Preview" onClick={this.onOpenEditor} style={{ width: '150px', height: '150px', borderRadius: '50%', boxShadow: '2px 2px 2px 1px rgba(0,0,0,0.3)' }} />
            </React.Fragment>
        )
    }
}

export default ProfileAvatar